import { ISearchable } from './Searchable.itf'


/**
* @typedef  PoissonQualiteConstructor
* @type {object}
* @property {Object} idQualite - the idQualite value
* @property {string} nom - the nom value
* @property {string} racc - the racc value
* @author generator-sqlite
* */
export class PoissonQualite extends ISearchable {
  /**
   * Creates an instance of PoissonQualite.
   * @memberof PoissonQualite
   * @author generator-sqlite
   * */
  constructor(object) {
    super()
    this.idQualite = object.idQualite
    this.nom = object.nom
    this.raccourci = object.racc
  }

  formatToDisplay() {
    this.nom = this.nom.charAt(0).toUpperCase() + this.nom.substring(1).toLowerCase()
    this.lineClassName = 'qualityLine'
    this.boxClassName = 'qualityBox'
    this.displayType = 'Qualité et affinage'
    this.created = true
    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-qualityLine'
    return this
  }

  getIdAttribute() {
    return 'idQualite'
  }

  getNameAttribute() {
    return 'nom'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
